import { render, staticRenderFns } from "./ClientSponsorshipsTab.vue?vue&type=template&id=40ba3070"
import script from "./ClientSponsorshipsTab.vue?vue&type=script&lang=js"
export * from "./ClientSponsorshipsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports